import { FilterValues } from "../../../data-model/filterValues";
import { EventForAuditTrail } from "../../../data-model/viewAllEvents";
import { processFilterData } from "../../../utils/queryConstraint";
import { EventTypeFilterGroups } from "./filterOptionsGenerator";

/**
 * Applies the active view-all-events filters client-side.
 *
 * Selected event-type values that are group values (see
 * {@link EventTypeFilterGroups}) are expanded into the raw `event_type` values
 * they cover before matching.
 *
 * @param data - Full list of audit trail events for the order.
 * @param filters - Current filter state for the view-all-events table.
 * @returns Subset of events matching the selected filters.
 */
export const generateFilteredDataForAllEvents = (
  data: EventForAuditTrail[],
  filters: FilterValues[],
) => {
  let filteredData = data;
  const filtersAfterProcessing = processFilterData(filters);
  const filterKeys = Object.keys(filtersAfterProcessing);
  for (const key of filterKeys) {
    if (key === "event_type") {
      const selectedEventTypes: string[] = filtersAfterProcessing[key].flatMap(
        (value: string) => EventTypeFilterGroups[value] ?? [value],
      );
      filteredData = filteredData.filter((event) =>
        selectedEventTypes.includes(event?.event_type ?? ""),
      );
    }
  }

  return filteredData;
};
